import React, { useEffect, useState, useRef } from "react";
import { NavLink, useParams, useNavigate } from "react-router-dom";
import Sidebar from "../components/Sidebar";
import { useJwt } from "react-jwt";
import { EditStoreAPI, GetstoreById, api_url } from "../apiconfig/authService";

function EditStore(props) {
  const navigate = useNavigate();
  const { _, isExpired } = useJwt(localStorage.getItem("accessToken"));
  if (isExpired) navigate("/");

  const [mediaData, setMediaData] = useState({});
  const [editedMediaData, setEditedMediaData] = useState({});
  const [newImage, setNewImage] = useState(null);
  const [newImageSupport, setNewImageSupport] = useState(null);
  const [message, setMessage] = useState("");
  const [isMessageRed, setIsMessageRed] = useState(false);
  const [newImagePreview, setNewImagePreview] = useState(null);
  const [newImageSupportPreview, setNewImageSupportPreview] = useState(null);

  const { storeid } = useParams();
  const imageInputRef = useRef();

  console.log("editedMediaData???????????", editedMediaData);
  useEffect(() => {
    (async () => {
      try {
        const response = await GetstoreById(
          storeid,
          localStorage.getItem("accessToken")
        );
        setMediaData(response.data._doc);
        setEditedMediaData(response.data._doc);
      } catch (error) {
        console.error("Error fetching store data:", error);
      }
    })();
  }, [storeid]);

  const handleChange = (field) => (e) => {
    const temp = { ...editedMediaData };
    temp[field] = e.target.value;
    setEditedMediaData(temp);
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    setNewImage(file);
    if (file) {
      const previewUrl = URL.createObjectURL(file);
      setNewImagePreview(previewUrl);
    }
  };

  const handleImageSupportChange = (e) => {
    const file = e.target.files[0];
    setNewImageSupport(file);
    if (file) {
      const previewUrl = URL.createObjectURL(file);
      setNewImageSupportPreview(previewUrl);
    }
  };

  const handleDiscardClick = () => {
    if (imageInputRef.current) {
      imageInputRef.current.value = "";
    }
    setNewImage(null);
    setNewImagePreview(null); // Reset main image preview
    setNewImageSupport(null);
    setNewImageSupportPreview(null); // Reset support image preview
    setEditedMediaData({ ...mediaData });
  };

  const handleSubmitClick = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("storeid", editedMediaData.storeid);
    formData.append("storename", editedMediaData.storename);
    formData.append("weburl", editedMediaData.weburl);
    formData.append("supporturl", editedMediaData.supporturl);

    if (newImage) {
      formData.append("image", newImage);
      formData.append("imagename", editedMediaData.image);
    }

    if (newImageSupport) {
      // If a separate support image is selected, append it for 'supportimage'
      formData.append("supportimage", newImageSupport);
      formData.append("supportimagename", editedMediaData.supportimage);
    }

    try {
      const response = await EditStoreAPI(
        formData,
        localStorage.getItem("accessToken")
      );
      if (response.status === 200) {
        props.setMessage(response.data.message);
        navigate("/stores");
      }
    } catch (err) {
      const errorMessage =
        err.response?.data?.error ||
        "An error occurred. Please try again later.";
      setIsMessageRed(true);
      setMessage(errorMessage);
      console.error("Error updating store:", err);
    }
  };

  return (
    <div className="dashboard-content">
      <Sidebar />
      <div className="body-cart tab-content dasContent p-4 bg-white rounded">
        <div className="d-flex justify-content-between align-items-start pb-4 border-bottom mb-4">
          <h1 className="heading h4 mb-0 fw-bold">Edit Store</h1>
          <NavLink to="/stores" className="btn btn-primary">
            View All
          </NavLink>
        </div>

        {message && (
          <div
            style={{ color: isMessageRed ? "red" : "black" }}
            className="alert alert-primary"
            role="alert"
          >
            {message}
          </div>
        )}

        <div className="tab-pane active storetab">
          <div className="row">
            <div className="form-group col-sm-12 col-lg-6 mb-3">
              <label>Store Name</label>
              <input
                type="text"
                value={editedMediaData?.storename || ""}
                onChange={handleChange("storename")}
                className="form-control custom-input my-3"
                placeholder="Store Name"
              />
            </div>
            <div className="form-group col-sm-12 col-lg-6 mb-3">
              <label>Web URL</label>
              <input
                type="text"
                value={editedMediaData?.weburl || ""}
                onChange={handleChange("weburl")}
                className="form-control custom-input my-3"
                placeholder="Web URL"
              />
            </div>
          </div>
          <div className="row">
            <div className="form-group col-sm-12 col-lg-6 mb-3">
              <label>Image</label>
              <input
                type="file"
                ref={imageInputRef}
                className="form-control custom-input my-3"
                onChange={handleImageChange}
              />
              {newImagePreview ? (
                <img
                  width="100px"
                  height="100px"
                  className="my-2"
                  src={newImagePreview}
                  alt="New Preview"
                />
              ) : editedMediaData?.image ? (
                <img
                  width="100px"
                  height="100px"
                  className="my-2"
                  src={`${api_url}/product/category/getCategoryImage/${editedMediaData.image}`}
                  alt="Current"
                />
              ) : null}
            </div>

            <div className="form-group col-sm-12 col-lg-6 mb-3">
              <label>Support URL</label>
              <input
                type="text"
                value={editedMediaData?.supporturl || ""}
                onChange={handleChange("supporturl")}
                className="form-control custom-input my-3"
                placeholder="Support URL"
              />
            </div>
          </div>
          <div className="row">
            <div className="form-group col-sm-12 col-lg-6 mb-3">
              <label>Support Image</label>
              <input
                type="file"
                ref={imageInputRef}
                className="form-control custom-input my-3"
                onChange={handleImageSupportChange}
              />
              {newImageSupportPreview ? (
                <img
                  width="100px"
                  height="100px"
                  className="my-2"
                  src={newImageSupportPreview}
                  alt="New Support Preview"
                />
              ) : editedMediaData?.supportimage ? (
                <img
                  width="100px"
                  height="100px"
                  className="my-2"
                  src={`${api_url}/product/category/getCategoryImage/${editedMediaData.supportimage}`}
                  alt="Current Support"
                />
              ) : null}
            </div>
          </div>
          <div className="row">
            <div className="form-group col-sm-12 col-lg-12 mb-3">
              <button
                type="button"
                onClick={handleDiscardClick}
                className="btn btn-danger text-uppercase px-4 my-3"
              >
                Discard
              </button>{" "}
              &nbsp;
              <button
                type="submit"
                onClick={handleSubmitClick}
                className="btn btn-primary text-uppercase px-4 my-3"
              >
                Save
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EditStore;
